import { motion } from "framer-motion";
import { Link } from "react-router";

import { Logo } from "@/client/components/logo";

export const Header = () => (
  <motion.header
    className="fixed inset-x-0 top-0 z-20"
    initial={{ opacity: 0, y: -50 }}
    animate={{ opacity: 1, y: 0, transition: { delay: 0.3, duration: 0.3 } }}
  >
    {/* <DonationBanner /> */}

    <div className="bg-gradient-to-b from-background to-transparent py-3">
      <div className="container flex items-center justify-between px-6 lg:px-12">
        <Link to="https://cv.villagehutaccounting.co.ke/">
          <Logo size={150} />
        </Link>
        {/* <Link to="https://villagehutaccounting.co.ke/" className="block text-sm font-bold text-orange-500">{`HOME`}</Link> */}
        <div />
      </div>
    </div>
  </motion.header>
);
